
<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field">

            <b-form-group label="First Name:" label-for="create-installation-user-firstName">
                <b-form-input id="create-installation-user-firstName" v-model="model.user.first_name" type="text"
                    required />
            </b-form-group>

            <b-form-group label="Last Name:" label-for="create-installation-user-lastName">
                <b-form-input id="create-installation-user-lastName" v-model="model.user.last_name" type="text"
                    required />
            </b-form-group>

            <b-form-group label="Email:" label-for="create-installation-user-email">
                <b-form-input id="create-installation-user-email" v-model="model.user.email" type="email" required />
            </b-form-group>
        </div>
    </div>
</template>

<script>

    import SearchSelect from '../../widgets/SearchSelect'
    export default {
        name: 'AccountStep',
        components: { SearchSelect },        
        props: {
            model: { type: Object }
        },

        data(){
            return{
                tabIndex: 0
            }
        },

        mounted(){ this.$emit('can-continue', {value: true}) },
    }

</script>
